<template>

    <form action enctype="multipart/form-data" method="post">
       
        <h6>
            <span class="number-title">3</span>
            Définissez le mode d'envoi
        </h6>

        <div class="row">
			<div class="col mt-3 mb-3">

                <m-form-radio
                    class="col-8"
                    label="Le message sera immédiatement envoyé"
                    name="publication_mode"
                    v-model="publicationMode"
                    value="0"
                    :disabled="!establishmentsSelected"
                    
                />
                    
                <m-form-radio
                    class="col-8 mt-1"
                    label="Le message sera envoyé en différé"
                    name="publication_mode"
                    v-model="publicationMode"
                    value="1"
                    :disabled="!establishmentsSelected"
                />

                <div class="row" v-show="publicationMode === '1'">
                    <div class="col ml-3">
                        <em-datepicker
                            v-model="outputPlanningObject.pl_datedebut"
                            type="datetime"

                            placeholder="Sélectionnez une date"
                            :show-time-panel="showTimePanel"
                            @close="handleOpenChange"
                            lang="fr-fr"
                            :disabled="!establishmentsSelected"
                            format="DD/MM/YYYY HH:mm"
                        >
                            <template v-slot:footer>
                            <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                                {{ showTimePanel ? 'sélection date' : 'sélection heure' }}
                            </button>
                            </template>
                        </em-datepicker>

                        <p v-if="!outputPlanningObject.pl_datedebut" class="alert alert-warning mt-2">
                            Veuillez spécifer une date / heure d'envoi en différé.
                        </p>
                        <p v-else class="alert alert-success mt-2">
                            L'envoi sera fait le {{ $moment(outputPlanningObject.pl_datedebut).format("DD/MM/YYYY à HH:mm") }}
                        </p>

                    </div>
                </div>
            </div>
        </div>

        <h6>
            <span class="number-title">4</span>
            Rédigez le message
        </h6>

        <div class="row">
			<div class="col mb-3"> 
        
                <m-form-text 
                    type="textarea"
                    v-model="outputPlanningObject.pl_message"
                    name="message"
                    placeholder="Saisissez votre message"
                    :rows="6"
                />

                <div v-show="!photoJoined">
                    <label class="fileContainer d-flex justify-content-center" for="planningmedia">
                        <input
                            type="file"
                            class="form-control inputImage"
                            @change="handleFile()"
                            id="planningmedia"
                            name="file"
                            ref="planningmedia"
                            style="display: none"
                        />
                    </label>
                </div>

                <div v-show="photoJoined">
                    <label id="container-media-planning" for="planningmedia" ref="previewContainer" style="width: 100%; max-height:100%; position:relative">
                        <div id="container-media-planning-content" ref="preview"></div>
                            <button class="btn btn-rotate mr-2 btn-img rotate-left" v-on:click.prevent="rotateFile($event, 'left')">
                        <icon name="undo-alt"></icon>
                        </button>
                        <button class="btn btn-rotate mr-2 btn-img rotate-right" v-on:click.prevent="rotateFile($event, 'right')">
                            <icon name="redo-alt"></icon>
                        </button>
                        <button class="btn btn-danger mr-2 btn-img trash" v-on:click.prevent="deleteFile($event)">
                            <icon name="trash-alt"></icon>
                        </button>
                    </label>
                </div>
                <div style="display: none">
                    <canvas ref="canvas" width="1024" height="768"></canvas>
                </div>
            </div>
        </div>
      </form>

</template>

<script>
const IMAGE_MAX = 1024;

export default {
    name: "ScheduleMessage",
    props: {
        inputPlanningObject: {
            type: Object,
            default: () => {}

        },
        establishmentsSelected: {
            type: [String, Number],
            default: undefined
        }
    },
    data() {
        return {
            outputPlanningObject: {
                pl_datedebut: this.$moment().toDate(),
                pl_dateend: null,
                pl_message: "",
                pl_cycle: "onetime",
                pl_weekdays: 0,
                pl_id: -1,
                pl_messagemedia: "",
                us_id: this.$store.state.user.us_id,
                en_ids: []
            },
            image: "",
            photo: true,
            imageSize: { width: 0, height: 0 },
            angle: 0,
            photoJoined: false,
            planningMessageIsURL: false,
            publicationMode: 0,
            showTimePanel: false
        };
    },

    methods: {

        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },

        handleOpenChange() {
            this.showTimePanel = false;
        },

        deleteFile() {
            if (this.photo) {
                document.querySelector(".trash").style.display = "none";
                document.querySelector(".rotate-left").style.display = "none";
                document.querySelector(".rotate-right").style.display = "none";
                this.image.src = "";
                this.image = null;
                this.photoJoined = false;
                this.$refs.planningmedia.value = null;
            }
        },

        handleFile() {
            if (this.$refs.planningmedia.files.length == 0) {
                return;
            }

            this.planningMessageIsURL = false;

            let file = this.$refs.planningmedia.files[0];
            let isImage = /^image\//.test(file.type);

            if (document.querySelector("#media-to-send")) {
                document.querySelector("#media-to-send").remove();
            }

            let img = new Image();

            img.style.width = "100%";
            //img.style.maxWidth = "300px";

            img.style.border = "1px solid #868b90";
            img.id = "media-to-send";

            this.photo = isImage ? true : false;

            let btn = document.querySelectorAll(".btn-img");

            btn.forEach(function(el) {
                el.style.display = "block";
            });

            this.photoJoined = true;

            const fileReader_base64 = new FileReader();

            fileReader_base64.onload = e => {
                img.src = fileReader_base64.result;
                setTimeout(() => {
                this.image = img;
                this.imageSize.width = img.width;
                this.imageSize.height = img.height;
                this.$refs.preview.appendChild(img);
                let { w, h } = this._calculateWidthHeightWithMax(IMAGE_MAX);
                let ctx = this.$refs.canvas.getContext("2d");
                ctx.canvas.width = w;
                ctx.canvas.height = h;
                ctx.drawImage(img, 0, 0, w, h);
                this.outputPlanningObject.pl_messagemedia = this.$refs.canvas.toDataURL();
                }, 500);
            };

            fileReader_base64.readAsDataURL(file);
        },

        rotateFile(event, sens) {

            this.angle = sens === "right" ? this.angle + 90 : this.angle - 90;
            if (this.angle === 360 || this.angle === -360) this.angle = 0;

            let max = this.$refs.previewContainer.offsetWidth;

            let translateY = 0,
                w = 0,
                h = 0;
            let { w: wOri, h: hOri } = this._calculateWidthHeightWithMax(IMAGE_MAX);

            let ctx = this.$refs.canvas.getContext("2d");
            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            ctx.save();

            if (this.angle === 90 || this.angle === -90 || this.angle === 270 || this.angle === -270) {
                w = Math.ceil(max / (this.imageSize.height / this.imageSize.width));
                h = max;

                if (sens === "right" && this.angle === 270) translateY = w - h;
                if (sens === "left" && this.angle === 90) translateY = w - h;
                if (this.angle === -90) translateY = w - h;
                this.$refs.previewContainer.style.height = w + "px";
                ctx.canvas.width = hOri;
                ctx.canvas.height = wOri;
                ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2);
                ctx.rotate((this.angle * Math.PI) / 180);
                ctx.drawImage(this.image, -ctx.canvas.width / 2, -ctx.canvas.height / 2, wOri, hOri);
            }
            if (this.angle === 0 || this.angle === 180 || this.angle === -180) {
                w = max;
                h = Math.ceil(max / (this.imageSize.width / this.imageSize.height));
                this.$refs.previewContainer.style.height = h + "px";
                ctx.canvas.width = wOri;
                ctx.canvas.height = hOri;
                ctx.translate(ctx.canvas.width / 2, ctx.canvas.height / 2);
                ctx.rotate((this.angle * Math.PI) / 180);
                ctx.drawImage(this.image, -ctx.canvas.width / 2, -ctx.canvas.height / 2, ctx.canvas.width, ctx.canvas.height);
            }

            if (document.querySelector("#media-to-send")) document.querySelector("#media-to-send").style.width = w + "px";
            if (document.querySelector("#media-to-send")) document.querySelector("#media-to-send").style.height = h + "px";

            this.$refs.preview.style.transform = "translate(0," + translateY + "px) rotate(" + this.angle + "deg)";
            if (!this.planningMessageIsURL) this.outputPlanningObject.pl_messagemedia = this.$refs.canvas.toDataURL();

            ctx.restore();
        },

        _calculateWidthHeightWithMax(max) {

            let w = this.imageSize.width,
                h = this.imageSize.height;

            if (this.imageSize.width > this.imageSize.height) {
                w = max;
                h = Math.ceil(max / (this.imageSize.width / this.imageSize.height));
            } else {
                w = Math.ceil(max / (this.imageSize.height / this.imageSize.width));
                h = IMAGE_MAX;
            }
            return { w, h };
        },

        resetData() {

            this.image = null;
            this.photo = false;
            this.$refs.planningmedia.value = null;
            this.$refs.preview.innerHTML = "";
            this.photoJoined = false;

            if (document.querySelector("#media-to-send")) {
                document.querySelector("#media-to-send").remove();
            }

            this.outputPlanningObject = {
                pl_datedebut: this.$moment(),
                pl_dateend: null,
                pl_message: "",
                pl_cycle: "onetime",
                pl_weekdays: 0,
                pl_id: -1,
                pl_messagemedia: "",
                us_id: this.$store.state.user.us_id,
                en_ids: []
            };
            this.imageSize = { width: 0, height: 0 };
            this.angle = 0;
            this.photoJoined = false;
            this.planningMessageIsURL = false;
        },

        getImagePreview(planningImageUrl) {

        this.planningMessageIsURL = true;
        let img = new Image();

        if (document.querySelector("#media-to-send")) {
            document.querySelector("#media-to-send").remove();
        }

        img.style.width = "100%";
        img.style.border = "1px solid #868b90";
        img.id = "media-to-send";

        let btn = document.querySelectorAll(".btn-img");

        btn.forEach(function(el) {
            el.style.display = "block";
        });

        img.src = this.$config.server_url + planningImageUrl;
        img.crossOrigin = "anonymous";
        img.onload = event => {
            // A FINIR
            this.photoJoined = true;
            let width = event.target.width;
            let height = event.target.height;
            this.image = event.target;
            this.imageSize.width = width;
            this.imageSize.height = height;
            this.$refs.preview.appendChild(this.image);
            let { w, h } = this._calculateWidthHeightWithMax(IMAGE_MAX);
            let ctx = this.$refs.canvas.getContext("2d");
            ctx.canvas.width = w;
            ctx.canvas.height = h;
            ctx.drawImage(this.image, 0, 0, w, h);
        };
    }

    },
    watch: {

        publicationMode(mode) {
            if(mode === "0") {
                this.outputPlanningObject.pl_datedebut = this.$moment().toDate();
            }
        },

        inputPlanningObject: {

            handler(value) {

                if (value && !this.$_.isEmpty(value)) {

                    this.$refs.preview.innerHTML = "";

                    if("pl_message" in value) {
                        this.outputPlanningObject.pl_message = value.pl_message;
                    }

                    if("pl_messagemedia" in value) {
                        this.outputPlanningObject.pl_messagemedia = value.pl_messagemedia;
                    }

                    if("pl_cycle" in value) {               
                        this.outputPlanningObject.pl_cycle = value.pl_cycle;
                    }

                    if("pl_cyclevalue" in value) {              
                        this.outputPlanningObject.pl_cyclevalue = value.pl_cyclevalue;
                    }

                    if("pl_datedebut" in value) {            
                        this.outputPlanningObject.pl_datedebut = new Date(value.pl_datedebut);
                        this.publicationMode = this.$moment().isBefore(value.pl_datedebut) ? "1" : "0";
                    }

                    if("pl_dateend" in value) {  
                        this.outputPlanningObject.pl_dateend = value.pl_dateend;
                    }

                    if("en_ids" in value) {  
                        this.outputPlanningObject.en_ids = value.en_ids;
                    }

                    if("pl_weekdays" in value) {  
                        this.outputPlanningObject.pl_weekdays = value.pl_weekdays;
                    }

                    if("pl_id" in value) {  
                        this.outputPlanningObject.pl_id = value.pl_id;
                    }

                    if (this.outputPlanningObject.pl_messagemedia.indexOf("/public/") >= 0) {
                        this.planningMessageIsURL = true;
                        this.getImagePreview(this.outputPlanningObject.pl_messagemedia);
                    }
                }
            },
            deep: true
        },

        outputPlanningObject: {
            handler(value, oldValue) {
                if (value) {
                    this.$emit("saveplanning", value);
                }
            },
            deep: true
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.align-self-center:hover {
  background-color: lightgray;
}

.col-md-1 {
  border: 1px solid grey;
  padding: 2px;
  margin: 4px;
  text-align: center;
}
.col-md-1:hover {
  background-color: lightgray;
}
#media-to-send {
  transform-origin: left;
}
.btn-img {
  padding: 6px;
  display: none;
  position: absolute;
  bottom: 0px;
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
  border: 1px solid #b7b5b5;
}
.rotate-left {
  right: 100px;
}
.rotate-right {
  right: 60px;
}
.trash {
  right: 15px;
}
.btn-rotate {
  background-color: #ffffff8f;
}

.fileContainer {
  height: 80px;
  background-color: #ffffff;
  width: 100%;
  margin-bottom: 0;
  align-items: flex-end;
  border: 1px solid #ced4da;
  background-image: url("../../public/images/addphoto.png");
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
}

#container-media-planning {
    text-align: center;
    background-color: #c0c0c0;
}
</style>
